<div class="modal-header">
  <h2>
    {{cabecalho}}
  </h2>
</div>
<div class="modal-body">
  <label for="vistoriador">Informe uma nova data :</label>

  <div class="">
    <div class="">
      <label class="text-truncate mw-100" for="periodo">Período</label>
      <select [formControl]="formAgendamento.controls.periodo" type="text" id="periodo" class="form-control">
        <option value="">Selecione</option>
        <option value="0">Manhã</option>
        <option value="1">Tarde</option>
      </select>
    </div>
    <div class="">
      <label class="text-truncate mw-100" for="dataDesejada">Data Desejada</label>
      <input id="dataDesejada" [minDate]="dataInicioAgendamento" (focus)="dataDesejada.open()" (ngModelChange)="dataDesejada.toggle(); dataDesejada.close();$event.stopPropagation()" name="dataDesejada"
        [formControl]="formAgendamento.controls.dataAgendamento" ngbDatepicker #dataDesejada="ngbDatepicker"
        type="text" class="form-control" >
        <app-msg-erro [control]="formAgendamento.controls.dataAgendamento"></app-msg-erro>
    </div>
  </div>

</div>
<div class="modal-footer d-flex justify-content-between">
  <button (click)="activeModal.close(false)" class="btn btn-secondary px-lg-5">Cancelar</button>
  <button (click)="activeModal.close(formAgendamento)" [disabled]="formAgendamento.invalid" class="btn btn-success px-5">Confirmar</button>
</div>
